/**
 * Firebase Client SDK Configuration
 * ===================================
 * This initializes Firebase Authentication for email/password login.
 * The Firebase Web API Key and App ID are read from environment variables.
 *
 * HOW TO GET THESE VALUES:
 * 1. Go to https://console.firebase.google.com
 * 2. Select project: crypto-iris-482914-u4
 * 3. Click the gear icon → "Project settings"
 * 4. Scroll to "Your apps" → click your Web app (or add one if none exists)
 * 5. Copy the firebaseConfig values
 *
 * LOCAL DEV: Add values to frontend/.env
 * PRODUCTION: Add values in Vercel dashboard under Environment Variables
 *
 * SECURITY NOTE:
 * Firebase Web API Key is safe to expose in frontend code — it only identifies
 * your Firebase project and does NOT grant admin access.
 * Rate limiting, auth rules, and Firestore security rules protect your data.
 */

import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'crypto-iris-482914-u4-16270.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'crypto-iris-482914-u4-16270',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'crypto-iris-482914-u4-16270.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase (avoid re-initializing if already done — handles hot-reload)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Firebase Auth instance
export const auth = getAuth(app);

export default app;
